import req from "../http";

const workplace = {
  // 依查詢條件 取得工作地點(分頁)
  getWorkplacePaging(params) {
    return req("get", "/WorkPlace/paging", params);
  },

  // 取得 工作地點
  getWorkplace(params) {
    return req("get", "/WorkPlace", params);
  },

  // 依guid 取得工作地點
  getWorkplaceInfo(guid) {
    return req("get", `/WorkPlace/${guid}`);
  },

  // 新增 工作地點
  postWorkplace(params) {
    return req("post", "/WorkPlace", params);
  },

  // 更新 工作地點
  putWorkplace(params) {
    return req("put", "/WorkPlace/workplace", params);
  },

  // 刪除 工作地點
  deleteWorkplace(guid) {
    return req("delete", `/WorkPlace/${guid}`);
  },
};

export default workplace;